import getResponseJson from './getresponsejson';

export const dxWorkSectionService = serviceRoutes => {
  const addDx = (
    encounterId,
    cmsCodeId,
    supportingText,
    reasonOptions
  ) => {
    return fetch(serviceRoutes.addDx, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        encounterId,
        cmsCodeId,
        supportingText,
        reasonOptions
      })
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result: { listItems } } = responseJson;
      return Promise.resolve(listItems);
    })
    .catch(e => {
      console.error(e.toString());
    });
  };

  const approveDx = (
    encounterId,
    encounterCmsCodeIds,
    reasonOptions
  ) => {
    return fetch(serviceRoutes.approveDx, {
      credentials: 'include',
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        encounterId,
        encounterCmsCodeId: encounterCmsCodeIds,
        isApproved: true,
        reasonOptions
      })
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result: { listItems } } = responseJson;
      return Promise.resolve(listItems);
    })
    .catch(e => {
      console.error(e.toString());
    });
  };

  const setDxAsUnworked = (encounterId, encounterCmsCodeId) => {
    return fetch(serviceRoutes.setDxAsUnworked, {
      credentials: 'include',
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        encounterId,
        encounterCmsCodeId,
        isApproved: null
      })
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result: { listItems } } = responseJson;
      return Promise.resolve(listItems);
    });
  };

  const removeDx = (
    encounterId,
    encounterCmsCodeIds,
    reasonOptions
  ) => {
    return fetch(serviceRoutes.removeDx, {
      credentials: 'include',
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        encounterId,
        encounterCmsCodeId: encounterCmsCodeIds,
        isApproved: false,
        reasonOptions
      })
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result: { listItems } } = responseJson;
      return Promise.resolve(listItems);
    })
    .catch(e => {
      console.error(e.toString());
    });
  };

  const unapproveDx = (encounterId, encounterCmsCodeId) => {
    return setDxAsUnworked(encounterId, encounterCmsCodeId);
  };

  const unremoveDx = (encounterId, encounterCmsCodeId) => {
    return setDxAsUnworked(encounterId, encounterCmsCodeId);
  };

  const resolveAuditReason = (encounterAuditReasonId, resolutionTypeId) => {
    return fetch(serviceRoutes.resolveAuditReason, {
      credentials: 'include',
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        encounterAuditReasonId,
        resolutionTypeId
      })
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    });
  };

  return {
    addDx,
    approveDx,
    unapproveDx,
    removeDx,
    unremoveDx,
    resolveAuditReason,
    serviceRoutes
  };
};

export default dxWorkSectionService;
